import { RouteMonitoringApi, RouteMonitoring } from '../models';
import { normalizeRouteMonitoringVisitsFromApi } from './normalize-route-monitoring-visits';

export function mapRouteMonitoringApiToModel(
  routeMonitoringApi: RouteMonitoringApi
): RouteMonitoring {
  const visits = normalizeRouteMonitoringVisitsFromApi(
    routeMonitoringApi.visits as unknown[]
  );
  return {
    route: routeMonitoringApi.route,
    metrics: routeMonitoringApi.metrics,
    visits,
  };
}
